<template>
  <router-view />
</template>

<script>
export default {
  name: 'App',
}
</script>

<style lang="scss">
// ============================================
// 0. FORCE STYLE
// ============================================
* {
  font-family: 'Bai Jamjuree', sans-serif;
  font-size: inherit !important;
}

.group-head,
.detail-header,
.detail-content,
.group-body {
  padding: 20px !important;

  @media screen and (max-width: 768px) {
    padding: 15px !important;
  }
}

.group-head {
  .name {
    font-size: 12px !important;
  }
  img {
    height: 28px;
    width: auto;
  }
}

// ============================================
// 1. BASE & RESET
// ============================================
@import url('https://fonts.googleapis.com/css2?family=Bai+Jamjuree:wght@400;500;600&display=swap');

html,
body {
  background: #fffcf5;
  margin: 0px;
  box-sizing: border-box;
  height: 100vh;
  font-size: 12px !important;
}

input::-ms-reveal,
input::-ms-clear {
  display: none;
}

*,
*:before,
*:after {
  box-sizing: inherit;
}

p {
  margin: 0;
}

// ============================================
// 2. UTILITIES
// ============================================

.display-flex {
  display: flex;
  align-items: center;
}

.flex-column {
  display: flex;
  flex-direction: column;
}

.flex-wrap {
  flex-wrap: wrap;
}

.nowrap {
  text-wrap-mode: nowrap;
  flex-wrap: nowrap;
  white-space: nowrap;
}

.pointer {
  cursor: pointer;
}

.hyper-link {
  cursor: pointer;
  text-decoration: underline !important;
  text-decoration-color: #236092 !important;
  color: #236092 !important;
}

.link-blue-italic {
  color: #236092;
  font-style: italic;
  text-decoration: underline;
  cursor: pointer;
}

.text-secret {
  color: #999;
  font-style: italic;
  cursor: default;
}

.text-align-center {
  text-align: center !important;
}

.none-pointer {
  cursor: default !important;
}

.required,
.text-danger {
  color: red;
}

.w-25 {
  width: 25%;
}

.w-50 {
  width: 50%;
}

.w-75 {
  width: 75%;
}

.w-100 {
  width: 100%;
}

.gap-5 {
  gap: 5px;
}

.gap-10 {
  gap: 10px;
}

.gap-20 {
  gap: 20px;
}

.p-0 {
  padding: 0px !important;
}

.p-10 {
  padding: 10px;
}

.p-20 {
  padding: 20px;
}

.p-30 {
  padding: 30px;
}

.grid {
  display: grid;
}

.grid-cols-4 {
  grid-template-columns: repeat(4, 1fr);
}

.grid-cols-2 {
  grid-template-columns: repeat(2, 1fr);
}

.grid-cols-3 {
  grid-template-columns: repeat(3, 1fr);
}

.font-bold {
  font-weight: bold;
}

.truncated-text {
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
  line-clamp: 2;
  overflow: hidden;
  text-overflow: ellipsis;
  line-height: 1.4;
}

.group-overflow {
  overflow: auto;
}

.group-checkbox {
  display: flex;
  align-items: center;
  gap: 10px;
}

.title-name,
.name {
  color: #15466e !important;
  font-weight: 600 !important;
}

.text-success {
  color: #009900 !important;
}

.text-info {
  color: #15466e !important;
}

.border-0 {
  border: none !important;
}

// ============================================
// 3. BUTTONS
// ============================================

.button-back {
  border-radius: 5px;
  border: solid 1px #c1cfe3;
  background-color: transparent;
  display: flex;
  align-items: center;
  font-size: 12px;
  font-weight: 500;
  color: #15466e;
  text-decoration: none;
  text-wrap: nowrap;
  padding: 0;

  .icon-back {
    width: 18px;
    margin: 0 8px;
  }

  .icon-line {
    height: 100%;
    margin: 0 10px;
  }

  span {
    padding: 8px;
    border-left: 1px solid #c1cfe3;
  }
}

.button-create {
  width: fit-content;
  height: fit-content;
  padding: 8px 12px;
  color: #fff;
  border: 0px;
  border-radius: 5px;
  background-color: #007773;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 5px;
  text-wrap-mode: nowrap;
  text-decoration: none;

  img {
    height: 20px;
    width: auto;
  }
}

.btn {
  padding: 8px 12px;
  font-size: 12px;
  font-weight: 500;
  border-radius: 5px;
  border: 0px;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 5px;
  text-decoration: none;

  img {
    height: 20px !important;
    width: auto;
  }

  &:hover:not(:disabled) {
    transition: all 0.2s;
    filter: contrast(1.4);
  }
}

.btn-sm {
  padding: 4px 8px;
  font-size: 12px;
  border-radius: 5px;
  border: 0px;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 5px;
  text-decoration: none;

  img {
    height: 20px;
    width: auto;
  }
}

.btn-red {
  background-color: #fca3ac;
  color: #c50c1e;

  .number {
    padding: 4px 10px;
    border-radius: 12px;
    background-color: #cd2131;
    font-size: 12px;
    font-weight: bold;
    color: #ffffff;
  }
}

.btn-green {
  color: #ffffff !important;
  background-color: #007773 !important;
}

.btn-red-dark {
  color: #ffffff !important;
  background-color: #691208 !important;
}

.btn-primary {
  color: #ffffff !important;
  background-color: #007773 !important;
}

.btn-secondary {
  color: #ffffff !important;
  background-color: #15466e !important;
}

.btn-icon {
  height: 18px;
}

.btn-success {
  border: 0 !important;
  background-color: #007773 !important;
  color: #ffffff !important;
}

.btn-danger {
  border: 0 !important;
  background-color: #c85661 !important;
  color: #ffffff !important;
}

.btn-white {
  border: 1px solid #c1cfe3 !important;
  background-color: #ffffff !important;
  color: #374151 !important;
}

.icon-white {
  filter: brightness(0) invert(1);
}

.btn-info {
  border: 0 !important;
  background-color: rgb(23, 162, 184, 0.9) !important;
  color: #ffffff !important;
}

.btn-warning {
  border: 0 !important;
  background-color: rgb(255, 193, 7, 0.9) !important;
  color: #ffffff !important;
}

.btn-gray {
  background-color: #999;
  color: #ffffff !important;
}

.btn-light-green {
  background-color: #0b9e2c;
  color: #ffffff !important;
}

button:disabled,
button[disabled] {
  opacity: 0.65;
}

button {
  cursor: pointer;
  white-space: nowrap;
  &:disabled,
  &:disabled:hover {
    cursor: default;
  }
}

.batch-count {
  font-size: 11px;
  font-weight: 600;
  color: #15466e;
  background: #e2ebf7;
  padding: 3px 10px;
  border-radius: 12px;
  white-space: nowrap;
}

// ============================================
// 4. TRANSITIONS
// ============================================

.navigation-ham-enter-active,
.navigation-ham-leave-active {
  transition: width 0.5s ease-in-out;
  overflow: hidden;
}

.navigation-ham-enter,
.navigation-ham-leave-to {
  width: 0;
}

.expand-enter-active,
.expand-leave-active {
  transition: all 0.3s ease-in-out;
  max-height: 2000px;
  overflow: hidden;
}

.expand-enter-from,
.expand-leave-to {
  transition: all 0.3s ease-in-out;
  max-height: 0;
}

// ============================================
// 5. TABLE SORTING
// ============================================

th {
  position: relative;
}

.group-table-triangle {
  position: absolute;
  right: 10px;
  top: 50%;
  transform: translate(0%, -50%);

  .triangle-table-up {
    width: 0;
    height: 0;
    border-left: 5px solid transparent;
    border-right: 5px solid transparent;
    border-bottom: 7px solid #c5c9d4;
  }

  .triangle-table-down {
    width: 0;
    height: 0;
    border-left: 5px solid transparent;
    border-right: 5px solid transparent;
    border-top: 7px solid #c5c9d4;
    margin-top: 5px;
  }

  .triangle-table-up.active {
    border-bottom: 7px solid #0d304d;
  }

  .triangle-table-down.active {
    border-top: 7px solid #0d304d;
  }
}

// ============================================
// 6. BADGES & STATUS
// ============================================

.badge {
  padding: 2px 6px;
  border-radius: 5px;
  font-size: 12px;
  text-wrap-mode: nowrap;
  height: fit-content;
  width: fit-content;
  display: flex;
  gap: 5px;
  align-items: center;

  &.danger {
    background: #f94859;
    color: #ffffff !important;
  }

  &.warning {
    background: #fae4e7;
    color: #f94859 !important;
  }

  &.medium {
    background: #f9e8cf;
    color: #a36c16 !important;
  }

  &.normal {
    background: #d2eae9;
    color: #007773 !important;
  }
}

.circle-badge {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  min-width: 24px;
  height: 24px;
  border-radius: 50%;
  background-color: #15466e;
  color: #ffffff;
  font-size: 14px;
  font-weight: bold;
  padding: 4px;
  line-height: 1;
}

.delete-btn {
  display: flex;
  align-items: center;
  gap: 5px;
  padding: 8px 16px;
  border-radius: 5px;
  background-color: #fae4e7;
  color: #c50c1e;
  border: 0;
  font-size: 14px;
  font-weight: 500;

  &:hover {
    background-color: darken($color: #fae4e7, $amount: 2);
  }

  .icon-trash {
    width: 16px;
    height: 16px;
  }
}

.label-no {
  padding: 7px 25px;
  border-radius: 20px;
  font-weight: bold;

  &.light {
    color: #333;
    background-color: #f2f4f8;
  }

  &.dark {
    color: #15466e;
    background-color: #ced5db;
  }
}

// ============================================
// 7. ACTION BUTTONS (Desktop Pills)
// ============================================

.group-button {
  display: flex;
  flex-wrap: wrap;
  gap: 20px;
  width: 100%;

  .button {
    background-color: #c5c9d4;
    font-size: 12px;
    border-radius: 32px;
    border: 0px;
    color: #1a456b;
    font-weight: bold;
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 10px 20px;
    gap: 10px;

    .icon-archive-duotone {
      width: 31px;
      height: 28px;
      margin-right: 13px;
    }

    .icon-file-duotone {
      width: 22px;
      height: 31px;
      margin-right: 8px;
    }

    .icon-file-signature-duotone {
      width: 32px;
      height: 29px;
      margin-right: 6px;
    }

    .icon-bird {
      width: 45px;
      height: 36px;
      margin-right: 3px;
    }

    .icon-file-times-duotone {
      width: 23px;
      height: 30px;
      margin-right: 11px;
    }

    .number {
      padding: 4px 10px;
      border-radius: 12px;
      background-color: #002157;
      font-size: 12px;
      font-weight: bold;
      color: #ffffff;
    }
  }

  .red {
    background-color: #fca3ac;
    color: #c50c1e;

    .number {
      background-color: #cd2131;
    }

    &.active {
      background-color: #cd2131;
      color: #ffffff;
      filter: contrast(0.8);

      .number {
        background-color: #fff;
        font-size: 12px;
        font-weight: bold;
        color: #cd2131;
      }
    }
  }

  .end {
    margin-right: 0px;
  }

  .active {
    background-color: #1a456b;
    color: #ffffff;

    .number {
      background-color: #fff;
      font-size: 12px;
      font-weight: bold;
      color: #002157;
    }
  }

  .group-end {
    .button {
      font-size: 15px;
      background-color: #226f69;
      height: 50px;
      min-width: 160px;
      border-radius: 10px;
      border: none;
      color: #ffffff;
    }
  }
}

// ============================================
// 8. PAGE LAYOUT - List Pages (.detail)
// ============================================
.detail {
  width: 100%;
  height: 100%;
  min-height: 200px;
  border-radius: 15px;
  background-color: #fff;
  border: 0px;

  .group-head {
    display: flex;
    row-gap: 10px;
    flex-wrap: wrap;
    justify-content: space-between;
    border-bottom: 2px solid #e2ebf7;

    .group-first {
      display: flex;
      align-items: center;
      gap: 10px;

      img {
        height: 25px;
        width: auto;
        color: #0f3a64;
      }

      .name {
        color: #1a456b;
        font-weight: bold;
        font-size: 16px !important;
        text-wrap-mode: nowrap;
      }
    }

    .group-end {
      display: flex;
      width: fit-content;
      flex: 1;
      justify-content: flex-end;
      align-items: center;
      gap: 10px;

      .date {
        margin-right: 25px;
        width: 230px;
      }

      .search {
        min-width: 300px;
      }

      .advance-search {
        border-radius: 5px;
        background-color: #15466e;
        font-size: 12px;
        font-weight: 500;
        color: #fff;
        border: 0px;
        padding: 10px 15px;
      }
    }
  }

  .action-bar {
    display: flex;
    gap: 10px;
    margin: 20px;
    margin-bottom: 0px;

    button {
      font-size: 12px;
    }

    @media screen and (max-width: 768px) {
      margin: 15px;
      margin-bottom: 0px;
      flex-wrap: wrap;
    }
  }

  .group-body {
    display: flex;
    justify-content: space-between;
    flex-direction: column;
    align-items: center;
    overflow: auto;

    table {
      width: 100%;
      border-collapse: separate;
      border-spacing: 0px;
      border-radius: 5px;
      border: solid 1px #c1cfe3;
      background-color: #fff;

      thead {
        tr {
          font-weight: bold;
          font-size: 12px;
          color: #333333;
          height: 50px;

          th {
            border-bottom: solid 1px #c1cfe3;
            padding: 0 10px;
            text-align: center !important;
          }
        }

        .col1 {
          min-width: 85px;
          max-width: 85px;
          width: 0%;
          text-align: center;
        }
      }

      tbody {
        tr:nth-child(odd) {
          background-color: #ffffff;
        }

        tr:nth-child(even) {
          background-color: #f1f5fa;
        }
      }

      .tbody {
        .color-tr {
          background-color: #f1f5fa;
        }

        .tbody-row {
          width: 100%;
          height: 50px;
          text-align: center;
          color: #333333;
          border-bottom: 0px;
          font-weight: 500;
          font-size: 12px;

          td {
            padding: 10px;
          }

          .col-collapse {
            .group-angle {
              display: flex;
              align-items: center;
              justify-content: center;

              .icon-angle {
                margin-left: -20px;
                margin-right: 10px;
                font-size: 20px;
                color: #8aa3b7;
              }
            }
          }
        }
      }
    }

    .tr-color-colspan {
      background-color: #c6d7e5;
    }
  }
  .color-1 {
    background-color: #d2eae9;
    color: #007773;

    .bolt,
    .key {
      color: #007773;
    }
  }

  .color-2,
  .color-3 {
    background-color: #fae4e7;
    color: #f94859;

    .bolt,
    .key {
      color: #f94859;
    }
  }

  .color-4 {
    background-color: #f94859;
    color: #fff;

    .bolt,
    .key {
      color: #fff;
    }
  }

  .icon-clock-small {
    width: 17px;
    height: 17px;
  }

  .group-footer {
    padding: 0px 20px;
    padding-bottom: 20px;
  }

  .sub-table-card {
    padding: 20px;
    background-color: #c6d7e5;

    .sub-table {
      background-color: #fff;
      width: 100%;
      border-collapse: separate;
      border-spacing: 0px;

      tr {
        height: fit-content;
      }

      th {
        text-align: center !important;
        padding: 10px;
      }

      td {
        border-bottom: solid 1px #c1cfe3;
      }

      .sub-thead {
        background-color: #f1f5fa;

        .sub-thead-row {
          font-size: 12px;
          font-weight: 600;
          color: #333;

          .badge {
            font-size: 14px;
          }

          .col1 {
            min-width: 500px;
            width: 100%;
            text-align: left !important;
            padding-left: 60px;

            p {
              display: flex;
              gap: 10px;
            }
          }

          .col2 {
            min-width: 305px;
            max-width: 305px;
            width: 0%;
            text-align: left;
          }

          .col3 {
            min-width: 145px;
            max-width: 145px;
            width: 0%;
            text-align: left;
          }

          .col4 {
            min-width: 200px;
            max-width: 200px;
            width: 0%;
            text-align: center;
          }
        }
      }

      .sub-tbody {
        .sub-tbody-row {
          font-size: 12px;
          font-weight: 500;
          color: #333;

          td {
            padding: 0 60px;
            .sub-row-wrapper {
              display: flex;
              align-items: center;
              justify-content: space-between;
            }

            .text {
              font-size: 12px;
              min-width: 500px;
              width: 100%;
              text-align: left;
              line-height: 1.78;
              display: -webkit-box;
              -webkit-line-clamp: 2;
              line-clamp: 2;
              -webkit-box-orient: vertical;
              overflow: hidden;
              text-overflow: ellipsis;
            }

            .type-name {
              color: #007773;
              font-weight: bold;
            }
          }

          .bird {
            max-height: 28px;
            cursor: pointer;
          }

          .file {
            max-height: 28px;
            margin: 10px;
            cursor: pointer;
          }
        }
      }
    }
  }
}

td .tooltip {
  text-align: left;
  position: relative;
  display: block;
  width: 100%;

  a {
    display: -webkit-box;
    -webkit-line-clamp: 2;
    -webkit-box-orient: vertical;
    line-clamp: 2;
    white-space: normal;
    overflow: hidden;
    text-overflow: ellipsis;
    line-height: 1.4;
    width: 100%;
  }
}

.pdf-icon {
  width: 28px;
  height: 28px;
  cursor: pointer;
}

.row {
  display: flex;
  align-items: center;

  @media screen and (max-width: 768px) {
    flex-direction: column;
  }
}

.date-expire,
.present-by {
  font-size: 1.125rem;
  font-weight: 500;
  color: #666;
  display: flex;
  align-items: center;
}

.group-type-button {
  display: flex;
  margin: 20px;
  margin-bottom: 0px;
  padding: 0px;
  flex-wrap: wrap;
  gap: 10px;

  .type-button {
    display: flex;
    background-color: rgba(60, 109, 162, 0.3);
    border: 1px solid rgba(60, 109, 162, 0.3);
    color: #0d304d;
    border-radius: 32px;
    font-weight: bold;
    font-size: 12px;
    align-items: center;
    padding: 15px;
    gap: 10px;
    text-decoration: none;

    .group-image,
    .button-content {
      display: flex;
      align-items: center;
      gap: 5px;
    }

    .scroll {
      color: #3c6da2;
    }

    .badge-count {
      font-size: 12px;
      background-color: #3c6da2;
      color: #fff;
      border-radius: 12px;
      text-align: center;
      padding: 2px 10px;
    }
  }

  .active {
    background-color: #3c6da2;
    color: #ffffff;

    .scroll {
      color: #ffffff;
    }

    .badge-count {
      background-color: #ffffff;
      color: #3c6da2;
    }
  }
}

.mobile-type-status {
  display: none;
}

.group-level-button {
  display: flex;
  gap: 10px;
  flex-wrap: wrap;

  .name {
    text-wrap-mode: nowrap;
  }

  .group-button {
    display: inline-flex;
    gap: 10px;
  }

  .icon-bolt,
  .icon-key {
    font-size: 12px;
  }

  // Secret and Speed buttons styles
  .button-1,
  .button-2,
  .button-3,
  .button-4 {
    border-radius: 5px;
    box-shadow: 2.9px 0.8px 9.6px 0.4px rgb(137 148 169 / 35%);
    border: solid 2px #e2ebf7;
    background-color: #fff;
    font-size: 12px;
    font-weight: 500;
    padding: 6px;

    @media screen and (max-width: 768px) {
      padding: 5px;
    }
  }

  .button-1 {
    color: #007773;
  }

  .button-2,
  .button-3,
  .button-4 {
    color: #f94859;
  }

  .active {
    border: solid 3px #007773;
    background-color: #92d7d5;
  }

  .active2 {
    border: solid 3px #f94859;
    background-color: #fae4e7;
  }
}

// ============================================
// 9. PAGE LAYOUT - Form Pages (.detail-form)
// ============================================
.detail-form {
  width: 100%;
  height: 100%;
  min-height: 200px;
  border-radius: 15px;
  background-color: #fff;
  border: 0px;

  .group-head {
    display: flex;
    justify-content: space-between;
    align-items: center;
    border-bottom: 1px solid #e2ebf7;
    gap: 10px;

    .group-first {
      display: flex;
      gap: 10px;
      align-items: center;
      width: fit-content;

      img {
        max-height: 26px;
        width: auto;
      }

      .name {
        color: #1a456b;
        font-weight: bold;
        font-size: 16px !important;
        display: flex;
        width: fit-content;
        align-items: center;
        gap: 10px;
      }
    }

    .group-end {
      display: flex;
      gap: 10px;
      width: fit-content;
      align-items: center;
      flex-wrap: wrap;
    }

    @media screen and (max-width: 768px) {
      flex-wrap: wrap-reverse;
      gap: 15px;
      padding: 15px;

      .group-first {
        gap: 10px;
        width: 100%;
        flex-wrap: wrap;
      }
    }
  }

  .group-input {
    display: flex;
    flex-direction: column;
    gap: 10px;
  }

  .search-detail {
    padding: 20px 23px;

    .group-between {
      display: flex;
      gap: 30px;

      @media screen and (max-width: 1200px) {
        flex-direction: column;
        gap: 0;
      }
    }

    .group-input {
      width: 100%;
      padding: 0 10px;
      margin-bottom: 30px;

      .name {
        font-size: 12px;
        font-weight: bold;
        color: #333;
        margin-bottom: 7px;
      }
    }

    @media screen and (max-width: 768px) {
      padding: 15px;

      .group-input {
        padding: 0;
        margin-bottom: 20px;

        .name {
          font-size: 12px;
        }
      }
    }
  }

  .group-footer,
  .detail-end {
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 20px;
    border-top: 1px solid #e2ebf7;

    .footer-left,
    .footer-right {
      display: flex;
      gap: 10px;
    }

    .footer-right {
      margin-left: auto;
    }

    @media screen and (max-width: 768px) {
      flex-direction: column;
      gap: 10px;
      padding: 15px;

      button {
        width: 100%;
      }

      .footer-left,
      .footer-right {
        width: 100%;
        flex-direction: column;

        button,
        a.btn-danger,
        .btn-danger,
        .btn-success {
          width: 100%;
        }
      }
    }
  }

  .section-card .group-footer {
    border-top: none;
  }

  // Common Body Layouts
  .group-body {
    // Two-column layout pattern
    .between {
      display: flex;
      justify-content: space-between;
      gap: 20px;
    }
  }

  .info-grid {
    display: grid;
    grid-template-columns: repeat(auto-fit, minmax(180px, 1fr));
    justify-content: space-between;
    gap: 20px;

    .info-item {
      display: flex;
      flex-direction: column;
      gap: 10px;

      .info-label {
        font-size: 1.125rem;
        font-weight: 600;
        color: #333;
      }

      .info-value {
        display: flex;
        align-items: center;
        gap: 5px;
        font-size: 1.125rem;
        color: #333;

        .info-icon {
          width: 20px;
          height: 20px;
        }
      }

      .date-display,
      .text-desc {
        display: flex;
        align-items: center;
        gap: 10px;
        font-size: 1.125rem;
        color: #333;

        .icon-clock {
          width: 20px;
          height: 20px;
        }
      }
    }

    @media screen and (max-width: 768px) {
      gap: 10px;
    }
  }

  .reference-section {
    display: flex;
    align-items: center;
    flex-wrap: wrap;
    gap: 10px;
    width: 100%;

    .reference-number {
      background-color: #f2f4f8;
      padding: 7px 25px;
      border-radius: 20px;
      font-weight: bold;
      color: #333;
    }

    .text-no-small {
      font-weight: bold;
      color: #333;
    }

    .reference-date {
      display: flex;
      align-items: center;
      gap: 5px;

      img {
        height: 24px;
        width: auto;
      }
    }

    .file-download-wrapper {
      max-width: 50%;
      @media screen and (max-width: 768px) {
        max-width: 100%;
      }
    }
  }
}

.group-card-detail,
.section-card {
  border-radius: 10px;
  border: solid 1px #d8e1ea;
  margin: 20px;
  background: #ffffff;

  .group-name {
    padding: 20px;
    border-bottom: 1px solid #d8e1ea;
    font-size: 18px;
    font-weight: 500;
    color: #333;

    .name {
      display: flex;
      align-items: center;
      gap: 10px;
    }

    img {
      height: 32px;
      width: auto;
    }

    @media screen and (max-width: 768px) {
      padding: 15px;
    }
  }

  // Collapsible Card Title
  .card-title {
    padding: 20px;
    border-radius: 10px 10px 0 0;
    display: flex;
    align-items: center;
    gap: 10px;
    font-size: 1.125rem;
    font-weight: bold;
    color: #0f3a64;

    .title-icon {
      height: 30px;
      width: auto;
    }

    .title,
    .title-left {
      display: flex;
      align-items: center;
      gap: 10px;
      flex: 1;

      img {
        height: 30px;
        width: auto;
      }
    }

    .group-icon {
      display: flex;
      gap: 10px;
      img {
        max-height: 20px;
      }
    }

    &.collapsible {
      justify-content: space-between;
      cursor: pointer;

      .title-left {
        display: flex;
        align-items: center;
        gap: 10px;
        flex: 1;
      }

      .chevron-icon {
        width: 20px;
        height: 14px;
        transition: transform 0.3s;

        &.active {
          transform: rotate(180deg);
        }
      }

      &:hover {
        background-color: #f9fafc;
        border-radius: 10px;
      }
    }
  }

  .card-content {
    padding: 20px;
    border-top: 1px solid #d8e1ea;
    transition: all 0.3s ease;

    &.show {
      visibility: visible;
      opacity: 1;
      max-height: 5000px;
    }

    &.hide {
      visibility: hidden;
      opacity: 0;
      max-height: 0;
      padding: 0 20px;
      border-top: none;
      overflow: hidden;
    }

    @media screen and (max-width: 768px) {
      padding: 15px;
    }
  }
}

.mobile-cards {
  display: none;

  @media screen and (max-width: 768px) {
    display: flex;
  }

  flex-direction: column;
  gap: 10px;
  width: 100%;

  // List page pattern - simple cards
  .card {
    border: 1px solid #c1cfe3;
    border-radius: 8px;
    padding: 20px;
    background: #fff;
    display: flex;
    flex-direction: column;
    gap: 20px;

    .card-header {
      display: flex;
      justify-content: space-between;
      align-items: center;
      width: 100%;

      .title {
        display: flex;
        gap: 5px;
        width: 100%;
        justify-content: space-between;
        min-width: 0; // Allow flex children to shrink below content size
        overflow: hidden;

        p {
          font-weight: 600;
          font-size: medium;
          color: #0d304d;
          display: -webkit-box;
          -webkit-line-clamp: 2;
          -webkit-box-orient: vertical;
          line-clamp: 2;
          white-space: normal;
          overflow: hidden;
          text-overflow: ellipsis;
          line-height: 1.4;
          width: 100%;
        }
      }
    }

    .card-body {
      display: grid;
      grid-template-columns: 1fr 2fr;
      gap: 10px;
      font-size: 14px;

      .label {
        font-weight: 500;
      }
    }

    .card-actions {
      display: flex;
      align-items: center;
      gap: 10px;

      .link {
        color: #236092;
        text-decoration: underline;
        font-size: 14px;
      }
    }
  }

  // Common elements
  .no-data,
  .no-data-card {
    text-align: center;
    color: #666;
    padding: 30px;
    background: #f9f9f9;
    border-radius: 8px;
  }

  .load-more-container {
    text-align: center;
    margin-top: 20px;
  }

  .load-more-btn {
    padding: 10px 20px;
    border-radius: 5px;
    border: 1px solid #15466e;
    background-color: #fff;
    color: #15466e;
    font-weight: 500;
    cursor: pointer;
  }
}

.table-wrapper {
  width: 100%;
  overflow-x: auto;

  // For History Table
  .history-table {
    width: 100%;
    border-collapse: separate;
    border-spacing: 0;
    border: 1px solid #c1cfe3;
    border-radius: 5px;
    overflow: hidden;

    .col-index {
      min-width: 80px;
    }

    .col-operator {
      min-width: 150px;
    }

    .col-action {
      min-width: 150px;
    }

    .col-filename {
      min-width: 200px;
    }

    .col-date {
      min-width: 200px;
    }

    .col-file {
      min-width: 120px;
    }

    .col-remark {
      min-width: 200px;
    }

    thead {
      tr {
        background-color: #f2f4f8;

        th {
          padding: 20px 10px;
          text-align: center;
          font-size: 1.125rem;
          font-weight: bold;
          color: #333333;
          border-bottom: 1px solid #c1cfe3;
          white-space: nowrap;
        }
      }
    }

    tbody {
      tr {
        &:nth-child(odd) {
          background-color: #ffffff;
        }

        &:nth-child(even) {
          background-color: #f1f5fa;
        }

        td {
          padding: 15px 10px;
          font-size: 1rem;
          color: #333333;
          text-align: center;

          &.col-index {
            font-weight: 600;
          }

          &.col-operator,
          &.col-filename {
            text-align: left;
          }

          &.col-tools {
            img {
              height: 20px;
            }
          }

          &.no-data {
            text-align: center;
            padding: 30px;
            color: #888;
          }
        }
      }
    }
  }

  @media (max-width: 768px) {
    display: none;
  }
}

// ============================================
// History Mobile Cards
// ============================================
.history-mobile-cards {
  display: none;

  @media screen and (max-width: 768px) {
    display: block;
    margin-top: 15px;
  }

  .history-card {
    background: #fff;
    border: 1px solid #c1cfe3;
    border-radius: 8px;
    padding: 15px;
    margin-bottom: 15px;

    .card-header-mobile {
      display: flex;
      justify-content: space-between;
      align-items: center;
      padding-bottom: 10px;
      border-bottom: 1px solid #eee;
      margin-bottom: 10px;
      flex-wrap: wrap;
      gap: 10px;

      .card-index {
        font-weight: bold;
        color: #0f3a64;
        font-size: 1rem;
      }

      .card-action {
        font-weight: 600;
        color: #007773;
        background-color: #d2eae9;
        padding: 4px 12px;
        border-radius: 12px;
        font-size: 0.875rem;
      }

      .card-date {
        display: flex;
        align-items: center;
        gap: 5px;
        font-size: 0.875rem;
        color: #666;

        .info-icon {
          width: 16px;
          height: 16px;
        }
      }
    }

    .card-body-mobile {
      .data-row {
        display: flex;
        justify-content: space-between;
        margin-bottom: 8px;
        gap: 10px;

        .label {
          font-weight: 600;
          color: #555;
          font-size: 0.875rem;
        }

        .value {
          text-align: right;
          color: #333;
          font-size: 0.875rem;
          flex: 1;
        }
      }
    }
  }

  .no-data-card {
    text-align: center;
    padding: 30px;
    color: #888;
    background: #f9f9f9;
    border-radius: 8px;
  }
}

// ============================================
// 10. RESPONSIVE - Mobile (<768px)
// ============================================

@media screen and (max-width: 768px) {
  .group-type-button {
    display: none;
  }

  .mobile-type-status {
    display: block;
    margin: 20px;
  }

  .detail {
    .group-head {
      .group-first {
        width: 100%;
        flex-wrap: wrap;
      }

      .group-end {
        flex-direction: column;

        .search {
          min-width: 100%;
        }

        .advance-search {
          width: 100%;
        }
      }
    }

    .line {
      margin: 0px;
    }
  }

  .group-footer {
    display: none;
  }

  .badge {
    font-size: 14px;
  }

  // Global responsive footer styles
  .exam-footer,
  .detail-end {
    flex-direction: column !important;
    gap: 15px !important;
    padding: 20px 15px !important;

    .group-end-left,
    .group-end-right,
    .footer-left,
    .footer-right {
      width: 100%;
      margin-left: 0 !important;
      flex-direction: column;
      gap: 10px;
    }

    button,
    .button-times,
    .btn-success,
    .btn-success,
    .btn-primary,
    .btn-primary,
    .button-confirm,
    .button-callback,
    .button-save-remark,
    .button-confirm-content {
      width: 100% !important;
      margin-left: 0 !important;
      margin-right: 0 !important;
      font-size: 12px !important;
    }
  }

  // Responsive Typography
  .detail,
  .detail-form {
    .group-head .group-first .name {
      font-size: 14px !important;
    }
  }

  .group-card-detail .group-name .name,
  .section-card .title-tab .text-title {
    font-size: 14px !important;
  }

  .info-label {
    font-size: 0.875rem;
  }

  .text-desc,
  .contact-item,
  .doc-section-title {
    font-size: 14px;
  }

  table {
    .thead-row th {
      font-size: 14px;
    }

    .tbody-row td {
      font-size: 12px;
    }
  }
}

// ============================================
// 11. UTILITY - Publish Date Cell
// ============================================

.line {
  height: 2px;
  width: 100%;
  background-color: #e2ebf7;
}

.publish-date-cell {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 4px;
  @media screen and (max-width: 768px) {
    justify-content: start;
  }
}

.date-cell {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 5px;

  img {
    width: 18px;
    height: 18px;
  }

  @media screen and (max-width: 768px) {
    align-items: start;
  }
}

.col-date-set {
  min-width: 170px;
  text-align: center;
}
</style>
